import React from "react";

import { Container } from "./style";

export default function SideText({
  width,
  color,
  title = "",
  subTitle,
  zIndex = 0,
  ...props
}) {
  const titleWords = title.split(" ");

  let firstLine = titleWords[0];
  let secondLine = titleWords[1];

  if (titleWords.length === 3) {
    if (
      titleWords.slice(0, 2).join(" ").length >
      titleWords.slice(1, 3).join(" ").length
    ) {
      firstLine = titleWords.shift();
      secondLine = titleWords.join(" ");
    } else {
      secondLine = titleWords.pop();
      firstLine = titleWords.join(" ");
    }
  }

  if (titleWords.length === 4) {
    firstLine = titleWords.slice(0, 2).join(" ");
    secondLine = titleWords.slice(2, 4).join(" ");
  }

  return (
    <Container color={color} zIndex={zIndex} width={width}>
      <div className="title-content" style={{ animationDuration: "1s" }}>
        <h1 className="fade-in" style={{ animationDuration: "2s" }}>
          {firstLine}
        </h1>
        <h1 className="fade-in" style={{ animationDuration: "2s" }}>
          {secondLine}
        </h1>
        <p className="fade-in" style={{ animationDuration: "2.5s" }}>
          {subTitle}
        </p>
      </div>
      <div className="line-carousel" style={{ animationDuration: "2.5s" }}>
        <span className="first" />
        <span className="second" />
      </div>
    </Container>
  );
}
